(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvia-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class NuviaAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.nuvia-announce__item'));
      if (this.items.length < 2) return;

      this.index = 0;
      this.intervalMs = parseInt(this.dataset.rotateMs, 10) || 4000;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.prefersReducedMotion) return;

      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }

    next() {
      const current = this.items[this.index];
      this.index = (this.index + 1) % this.items.length;
      const nextItem = this.items[this.index];
      current.classList.remove('is-active');
      current.style.position = 'absolute';
      nextItem.classList.add('is-active');
      nextItem.style.position = 'relative';
    }

    disconnectedCallback() {
      this.stop();
    }
  }

  customElements.define('nuvia-announcement-bar', NuviaAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvia-buy-box"] && !Shopify.designMode) return;
  try {
    
  class NuviaBuyBox extends HTMLElement {
    connectedCallback() {
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.productJson = JSON.parse(this.querySelector('[data-nuvia-product-json]').textContent);
      this.variantIdInput = this.querySelector('[data-nuvia-variant-id]');
      this.priceEl = this.querySelector('[data-nuvia-price]');
      this.stickyPriceEl = this.querySelector('[data-nuvia-sticky-price]');
      this.atcButton = this.querySelector('[data-nuvia-atc]');
      this.atcText = this.querySelector('[data-nuvia-atc-text]');
      this.stickyAtcButton = this.querySelector('[data-nuvia-sticky-atc-button]');
      this.optionInputs = Array.from(this.querySelectorAll('[data-nuvia-option-input]'));

      this.optionInputs.forEach((input) => {
        input.addEventListener('change', () => this.handleOptionChange());
      });

      this.setupMediaSwitcher();
      this.setupStickyAtc();
    }

    getSelectedOptions() {
      const fieldsets = Array.from(this.querySelectorAll('[data-nuvia-option-position]'));
      return fieldsets
        .sort((a, b) => Number(a.dataset.nuviaOptionPosition) - Number(b.dataset.nuviaOptionPosition))
        .map((fieldset) => {
          const checked = fieldset.querySelector('[data-nuvia-option-input]:checked');
          return checked ? checked.value : null;
        });
    }

    findMatchingVariant(selectedOptions) {
      return this.productJson.variants.find((variant) => {
        const variantOptions = [variant.option1, variant.option2, variant.option3].filter(
          (value) => value !== null && value !== undefined
        );
        return (
          variantOptions.length === selectedOptions.length &&
          variantOptions.every((value, index) => value === selectedOptions[index])
        );
      });
    }

    handleOptionChange() {
      const selected = this.getSelectedOptions();
      const variant = this.findMatchingVariant(selected);
      if (!variant) return;
      this.updateForVariant(variant);
    }

    updateForVariant(variant) {
      if (this.variantIdInput) this.variantIdInput.value = variant.id;

      const formatted = this.formatMoney(variant.price);
      const compareFormatted = variant.compare_at_price > variant.price ? this.formatMoney(variant.compare_at_price) : null;
      this.renderPrice(this.priceEl, formatted, compareFormatted);
      this.renderPrice(this.stickyPriceEl, formatted, compareFormatted);

      const available = variant.available;
      [this.atcButton, this.stickyAtcButton].forEach((btn) => {
        if (!btn) return;
        btn.disabled = !available;
      });
      if (this.atcText) {
        this.atcText.textContent = available ? this.atcText.dataset.labelAvailable : this.atcText.dataset.labelSoldOut;
      }

      if (variant.featured_media) {
        const target = this.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (target) this.showMedia(target);
      }
    }

    formatMoney(cents) {
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = this.moneyFormat.match(placeholderRegex);
      const key = match ? match[1] : 'amount';

      const withDelimiters = (number, precision, thousands, decimalSep) => {
        const amount = (number / 100).toFixed(precision);
        const parts = amount.split('.');
        const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? dollars + decimalSep + parts[1] : dollars;
      };

      let value;
      switch (key) {
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = withDelimiters(cents, 2, ',', '.');
      }

      return match ? this.moneyFormat.replace(placeholderRegex, value) : '$' + value;
    }

    renderPrice(el, price, comparePrice) {
      if (!el) return;
      el.innerHTML = comparePrice
        ? '<span class="nuvia-price__sale">' + price + '</span> <s class="nuvia-price__compare">' + comparePrice + '</s>'
        : '<span>' + price + '</span>';
    }

    setupMediaSwitcher() {
      const thumbs = Array.from(this.querySelectorAll('.nuvia-buy-box__thumb'));
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const target = this.querySelector('[data-nuvia-main-media] [data-media-id="' + thumb.dataset.mediaId + '"]');
          if (target) this.showMedia(target);
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    }

    showMedia(target) {
      const items = this.querySelectorAll('[data-nuvia-main-media] .nuvia-buy-box__main-item');
      items.forEach((item) => {
        const isTarget = item === target;
        item.hidden = !isTarget;
        item.classList.toggle('is-active', isTarget);
        if (isTarget) {
          const img = item.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        }
      });
    }

    setupStickyAtc() {
      const sticky = this.querySelector('[data-nuvia-sticky-atc]');
      const trigger = this.atcButton;
      if (!sticky || !trigger || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            sticky.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(trigger);
    }
  }

  customElements.define('nuvia-buy-box', NuviaBuyBox);

  } catch(e) { console.error(e); }
})();
})();
